module.exports = __webpack_public_path__ + "static/media/radio.aee4cf50.svg";